import { useMemo } from 'react';
import { useExtraConfigContext } from '@gov-nx/core/app';
import type { MyFilesBadge } from '../context.types';
import { MyFilesSource } from '../context.types';

const BADGES = [
	{
		nameCode: 'filtr.zdroj.vse' as const,
		icon: 'collection',
	},
	{
		nameCode: `filtr.zdroj.${MyFilesSource.VSTUP_NEBO_VYSTUP_PODANI}` as const,
		icon: 'file-earmark-text',
		source: MyFilesSource.VSTUP_NEBO_VYSTUP_PODANI,
	},
	{
		nameCode: `filtr.zdroj.${MyFilesSource.PRILOHA_DATOVE_ZPRAVY}` as const,
		icon: 'datovka-fill',
		source: MyFilesSource.PRILOHA_DATOVE_ZPRAVY,
	},
	{
		nameCode:
			`filtr.zdroj.${MyFilesSource.UZIVATELEM_NAHRANY_DOKUMENT}` as const,
		icon: 'upload',
		source: MyFilesSource.UZIVATELEM_NAHRANY_DOKUMENT,
	},
	{
		nameCode: 'filtr.zdroj.kos' as const,
		icon: 'trash',
	},
	{
		nameCode: 'filtr.zdroj.bez-souboru' as const,
		icon: 'card-text',
		isFile: false,
	},
] satisfies readonly MyFilesBadge[];

const getBadge = (index: number, badges: MyFilesBadge[]) =>
	Number.isInteger(index) && index >= 0 && index < badges.length
		? badges[index]
		: undefined;

export const useMyFilesBadges = (selectedBadgeIndex: number) => {
	const {
		extraConfig: {
			pageRoutes: {
				myFilesConfig: { showWithoutFile, isUploadAllowed },
			},
		},
	} = useExtraConfigContext();

	const badges = useMemo(
		() =>
			BADGES.filter((b) =>
				b.nameCode === 'filtr.zdroj.bez-souboru' ? showWithoutFile : true
			).filter((b) =>
				b.source === MyFilesSource.UZIVATELEM_NAHRANY_DOKUMENT ||
				b.source === MyFilesSource.PRILOHA_DATOVE_ZPRAVY ||
				b.nameCode === 'filtr.zdroj.vse'
					? isUploadAllowed
					: true
			),
		[isUploadAllowed, showWithoutFile]
	);

	const selectedBadge = getBadge(selectedBadgeIndex, badges);

	return {
		badges,
		isFile: selectedBadge?.isFile,
		source: selectedBadge?.source,
		isSelectedRecycleBin: selectedBadge?.nameCode === 'filtr.zdroj.kos',
		isSelectedWithoutFile:
			selectedBadge?.nameCode === 'filtr.zdroj.bez-souboru',
	};
};
